import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { ProductAction } from 'src/actions/product.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  DEFAULT_HOMEPAGE_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getProductStatus } from 'src/utils/utils';
import {
  Button,
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';

import { useParams } from "react-router-dom";

import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";

import numeral from 'numeral';

import { Helmet } from "react-helmet";

import iconMobifone from "../../assets/images/icon_mobifone.png";
import iconVinaphone from "../../assets/images/icon_vinaphone.png";
import iconViettel from "../../assets/images/icon_viettel.png";
import ProductPrice1 from '../product-detail/ProductPrice1';
import CustomSlider2 from '../CustomSlider2';
import ProductViewDialog from './ProductViewDialog';

const TheHomepageProductDetail = ({ ...rest }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPage = queryParams.get("page");
  const { type, keyword } = useParams();
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [homepageProductLimit, setLimit] = useState(DEFAULT_HOMEPAGE_ROW_PER_PAGE);
  const [homepageProductPage, setPage] = useState(currentPage ? parseInt(currentPage) - 1 : 0);
  const { homepageProductItems, homepageProductTotal, homepageProductFilter } = useSelector(state => state.product);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)
  const { isLoading } = useSelector(state => state.app);
  const [selectedIndexes, setSelectedIndexes] = useState({});
  const [currentProductId, setCurrentProductId] = useState("");
  const [currentPriceIndex, setCurrentPriceIndex] = useState("");
  const [currentProduct, setCurrentProduct] = useState(null);
  
  useEffect(() => {
    setPage(currentPage ? parseInt(currentPage - 1): 0);
  }, [currentPage])
  
  useEffect(() => {
    const payload = {
      ...homepageProductFilter,
      homepageProductLimit: homepageProductLimit,
      homepageProductPage: homepageProductPage,
      product_type: type ? type.replace(/-/g, "_") : null,
      name: keyword,
    };
    dispatch(ProductAction.updateHomepageFilter(payload));
    dispatch(ProductAction.homepageList())
  }, [type, keyword, homepageProductPage, homepageProductLimit])

  const handleSelectAll = (event) => {
    let newSelectedProductIds;

    if (event.target.checked) {
      newSelectedProductIds = homepageProductItems.map((product) => product.slug);
    } else {
      newSelectedProductIds = [];
    }

    setSelectedProductIds(newSelectedProductIds);
  };

  const handleSelectOne = (event, id) => {
    const priceIndex = selectedProductIds.indexOf(id);
    let newSelectedProductIds = [];

    if (priceIndex === -1) {
      newSelectedProductIds = newSelectedProductIds.concat(selectedProductIds, id);
    } else if (priceIndex === 0) {
      newSelectedProductIds = newSelectedProductIds.concat(selectedProductIds.slice(1));
    } else if (priceIndex === selectedProductIds.length - 1) {
      newSelectedProductIds = newSelectedProductIds.concat(selectedProductIds.slice(0, -1));
    } else if (priceIndex > 0) {
      newSelectedProductIds = newSelectedProductIds.concat(
        selectedProductIds.slice(0, priceIndex),
        selectedProductIds.slice(priceIndex + 1)
      );
    }

    setSelectedProductIds(newSelectedProductIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);

    // Gán giá trị mặc định
    queryParams.set("page", newPage + 1);

    // Cập nhật URL mà không reload trang
    navigate({
      pathname: location.pathname,
      search: `?${queryParams.toString()}`
    }, { replace: true }); // replace để không thêm vào lịch sử trình duyệt
  };

  const handleConfirmOpen = (type, product) => {
    setSelected(product);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(ProductAction.del(selected.slug))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(ProductAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const totalPages = Math.ceil(homepageProductTotal / homepageProductLimit);
  
  const renderPagination = () => {
      const pages = [];
      const maxPagesToShow = 5;
      
      if (totalPages <= maxPagesToShow) {
          for (let i = 0; i < totalPages; i++) {
              pages.push(i);
          }
      } else {
          if (homepageProductPage > 2) pages.push(0, "...");
          for (let i = Math.max(0, homepageProductPage - 2); i <= Math.min(totalPages - 1, homepageProductPage + 2); i++) {
              pages.push(i);
          }
          if (homepageProductPage < totalPages - 3) pages.push("...", totalPages - 1);
      }
      
      return pages.map((page, index) => (
          <button className={`page-btn ${typeof page === "number" ? (currentPage && parseInt(currentPage) == page + 1 || !currentPage && page == 0 ? "current-selected" : "") : "not-number"}`} key={index} onClick={(e) => typeof page === "number" && handlePageChange(e, page)}
              disabled={page === homepageProductPage || page === "..."} style={{
                  padding: "8px 12px", background: page === homepageProductPage ? "var(--main-color)" : "var(--main-color)", color: "#fff",
                  border: "none", borderRadius: "5px", cursor: page === homepageProductPage || page === "..." ? "default" : "pointer",
                  margin: "0", transition: "0.3s"
              }}>
              {page === "..." ? "..." : page + 1}
          </button>
      ));
  };

  const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // hoặc 'auto'
    });
  };

  const categoryName = type => {
    if (type === 'xe-may-dien') {
        return "Xe máy điện"
    } else if (type === 'xe-dap-dien') {
        return "Xe đạp điện"
    } else if (type === 'ac-quy') {
        return "Ắc quy"
    } else if (type === 'pin') {
        return "Pin"
    } else if (type === 'phu-tung') {
        return "Phụ tùng"
    } else {
        return "Sản phẩm khác"
    }
  };

  const handlePriceChange = (productId, priceIndex) => {
    console.log(productId, ' || ', priceIndex);

    setSelectedIndexes({
      ...selectedIndexes,
      [productId]: priceIndex,
    })
  }

  const viewProduct = (product, productId, priceIndex) => {
    console.log(product, ' || ', productId, ' || ', priceIndex);

    setCurrentProduct(product);
    setCurrentProductId(productId);
    setCurrentPriceIndex(priceIndex);
    setOpen(true);
  };

  return (
    <>
        <Helmet>
            <title>{keyword ? 'Tìm kiếm \'' + keyword + '\'' : categoryName(type)} | Xe điện SH - Xe điện Song Đan</title>
        </Helmet>

        <h2 class="discover-title">
            <span class="style-title01">{keyword ? 'TÌM KIẾM' : 'KHÁM PHÁ'}</span>
            <span class="style-title02">{keyword ? '"' + keyword + '"' : categoryName(type)}</span>
		</h2>

        {isLoading && <div className='loading'></div>}

        {!isLoading && <div className='regular-list-show' style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "20px" }}>
            {homepageProductItems && homepageProductItems.slice(homepageProductPage * homepageProductLimit, homepageProductPage * homepageProductLimit + homepageProductLimit).map((product, index) => (
                product ? <div className="regular-item" style={{ display: "block", alignItems: "center", gap: "10px", padding: "10px", borderRadius: "0", background: "transparent", textDecoration: "none", color: "inherit" }}>
                    {product.trang_thai == "het_hang" && <div class="pause-stamp">HẾT HÀNG</div>}
                    {product.images && product.images.length > 0 && (() => {
                        let _images = [];

                        if (product.images && product.images.length > 0) {
                            _images = [...product.images].sort((a, b) => a.index - b.index);
                        }
                        return (
                          <div className='image-container' onClick={() => viewProduct(product, product.id, typeof selectedIndexes[product.id] !== 'undefined' && selectedIndexes[product.id] ? selectedIndexes[product.id] : '0')}>
                            <CustomSlider2 className="product-detail-banner" banners={_images} showSlideCount={1} showPrevBtn={0} showNextBtn={0} />
                          </div>
                        );
                    })()}
                    <div style={{ opacity: product.trang_thai == "het_hang" ? "0.8" : "1.0", width: "100%" }}>
                        <div className="name" onClick={() => viewProduct(product, product.id, typeof selectedIndexes[product.id] !== 'undefined' && selectedIndexes[product.id] ? selectedIndexes[product.id] : '0')}>{product.name}</div>
                        <div className="price">
                            <ProductPrice1 product={product} onSelectChange={(priceIndex) => handlePriceChange(product.id, priceIndex)} />
                        </div>

                        <div className='view-btn-region'>
                          <Button onClick={() => viewProduct(product, product.id, typeof selectedIndexes[product.id] !== 'undefined' && selectedIndexes[product.id] ? selectedIndexes[product.id] : '0')} class="btn-view btn-buy-now bestSale-btn add-to-cart-v3s btn-sale">
                              <p>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor" width="18" height="18">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7
                                          -1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                              </p>
                          </Button>

                          <Link to={`/trang-chu/san-pham/${product.product_type.replace(/_/g, "-")}/${product.slug}?priceIndex=${typeof selectedIndexes[product.id] !== 'undefined' && selectedIndexes[product.id] ? selectedIndexes[product.id] : '0'}`} class="btn-buy-now bestSale-btn add-to-cart-v3s btn-sale">
                              <p>
                                  MUA NGAY
                                  <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1.25 1.08008L6 5.54075L1.25 10.0014" stroke="white"></path>
                                  </svg>
                              </p>
                          </Link>
                        </div>
                    </div>
                </div> : null
            ))}
        </div>}

        {!isLoading && <div className='list-pagination' style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px", gap: "5px" }}>
            <button onClick={(e) => handlePageChange(e, homepageProductPage - 1)} disabled={homepageProductPage === 0} style={{ padding: "10px 15px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", transition: "0.3s" }}
            onMouseEnter={e => e.target.style.background = "var(--main-color)"}
            onMouseLeave={e => e.target.style.background = "var(--main-color)"}>
                {"<"}
            </button>
            {renderPagination()}
            <button onClick={(e) => handlePageChange(e, homepageProductPage + 1)} disabled={homepageProductPage + 1 >= homepageProductTotal / homepageProductLimit} style={{ padding: "10px 15px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", transition: "0.3s" }}
            onMouseEnter={e => e.target.style.background = "var(--main-color)"}
            onMouseLeave={e => e.target.style.background = "var(--main-color)"}>
                {">"}
            </button>
        </div>}

        <ProductViewDialog open={open} handleClose={handleClose} type={"EDIT"} product={currentProduct} productId={currentProductId} priceIndex={currentPriceIndex} />
    </>
  );
};

export default TheHomepageProductDetail;
